module.exports = __webpack_public_path__ + "img/full-screen-icon.7d8620fe.svg";